import { CellProps } from "@jsonforms/core";
import { withJsonFormsCellProps } from "@jsonforms/react";

import { Checkbox } from "@/components/primitives/Checkbox";

function CheckboxCellComponent({
  data,
  handleChange,
  path,
  enabled,
}: CellProps) {
  return (
    <Checkbox
      checked={!!data}
      onChange={(e) => handleChange(path, e.target.checked)}
      disabled={!enabled}
    />
  );
}

export const CheckboxCell = withJsonFormsCellProps(CheckboxCellComponent);
